// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lMT5BSESfmWrxhaPQd-wnw\\=\\={width:415px}", "",{"version":3,"sources":["webpack://./src/shared/components/QRCodeOptionsSelector/QRCodeOptionsSelector.module.scss"],"names":[],"mappings":"AAAA,4BACE,WAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"QRCodeSelectionContainer": "lMT5BSESfmWrxhaPQd-wnw=="
};
export default ___CSS_LOADER_EXPORT___;
